module.exports = __webpack_public_path__ + "static/media/logo.56ce0762.png";